import config from "../config/config";
import { getToken } from "../utils/prefix";

export async function upload_videoAPI(data) {
  var formdata = new FormData();
  formdata.append("title", data.title);
  formdata.append("file", data.file);
  const res = await fetch(config.api_backend + `/task/create`, {
    body: formdata,
    method: "POST",
    headers: {
      "x-access-token": getToken(),
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_videoAPI(data) {
  const res = await fetch(
    config.api_backend + `/task/download?task_id=${data.task_id}`,
    {
      //   body: data,
      method: "GET",
      headers: {
        "x-access-token": getToken(),
        //   "Content-type": "application/json",
      },
    }
  );

  const dataRespone = await res.arrayBuffer();
  return dataRespone;
}

// test
export async function upload_file(data) {
  try {
    // สร้าง FormData เพื่อเก็บข้อมูล
    var formdata = new FormData();
    formdata.append("task_id", data.task_id); // เพิ่ม task_id
    formdata.append("type", data.type); // เพิ่ม type (dataset)
    formdata.append("name", data.name); // เพิ่มชื่อไฟล์
    formdata.append("file", data.file); // เพิ่มไฟล์

    // ส่งคำขอแบบ POST ไปยัง API
    // const res = await fetch(`${config.api_backend}/media/task`, {
    const res = await fetch(config.api_backend + `/media/upload`, {
      method: "POST",
      body: formdata, // ใช้ formdata เป็น body
      headers: {
        "x-access-token": getToken(), // เพิ่ม token สำหรับ authentication
      },
    });

    // ตรวจสอบผลตอบกลับ
    if (!res.ok) {
      throw new Error(`HTTP Error! status: ${res.status}`);
    }

    // แปลงผลลัพธ์เป็น JSON
    const dataResponse = await res.json();

    // คืนค่าผลลัพธ์ (response)
    return {
      status: dataResponse.status,
      link: dataResponse.link,
    };
  } catch (error) {
    console.error("File upload failed:", error);
    throw error; // ส่ง error กลับไปที่ caller
  }
}

export async function post_uploadResult(data) {
  var formdata = new FormData();
  formdata.append("task_id", data.task_id); // เพิ่มไฟล์
  formdata.append("user_id", data.user_id); // เพิ่มไฟล์
  formdata.append("type", data.type); // เพิ่มไฟล์
  formdata.append("name", data.name); // เพิ่มไฟล์
  formdata.append("file", data.file); // เพิ่มไฟล์
  const res = await fetch(config.api_backend + `/media/uploadResult`, {
    body: formdata,
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      //   "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}
